import { AxiosError } from 'axios';
import instance from '../config/axios';
import {
  OrderStatusKeys,
  PaginationServiceProps,
  SelectedAusPostData,
} from '../interface/interface';
import { stringify } from 'qs';

export const getOrderDetails = async (accessToken: string, orderId: number) => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/order-details/${orderId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status === 200 ? response.data : response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const getOrderProductDetailsById = async (
  accessToken: string,
  orderId: string,
) => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/order-details/${orderId}/products`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status === 200 ? response.data : response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const addAuspostId = async (
  accessToken: string,
  ausPostData: SelectedAusPostData,
) => {
  try {
    const response = await instance({
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      url: 'api/v1/order/update-auspost-id',
      data: { ...ausPostData },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const downloadOrderInvoice = async (
  accessToken: string,
  orderId: number,
) => {
  try {
    return await instance({
      url: `/api/v1/order/${orderId}/invoice`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: 'blob',
    });
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const updateOrderStatus = async (
  accessToken: string,
  data: OrderStatusKeys,
) => {
  try {
    const response = await instance({
      method: 'POST',
      url: '/api/v1/order/status',
      data: { ...data },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const resumeOrder = async (accessToken: string, orderId: number) => {
  try {
    const response = await instance({
      url: '/api/v1/order/status/resume',
      method: 'PUT',
      data: {
        orderId,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const getOrderListForAdmin = async (
  accessToken: string,
  pagination: PaginationServiceProps,
) => {
  try {
    const response = await instance({
      url: `/api/v1/admin/orders?${stringify(pagination)}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'GET',
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const getAllOrderStatues = async (accessToken: string) => {
  try {
    const response = await instance({
      method: 'GET',
      url: '/api/v1/order/status/list',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const getOrderInfoForPatient = async (
  accessToken: string,
  orderId: number,
) => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/order-details/patient/${orderId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status === 200 ? response.data : response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export const getPatientOrderProductListByOrderId = async (
  accessToken: string,
  orderId: string,
) => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/patient-order-details/${orderId}/products`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status === 200 ? response.data : response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};

export async function addNote(
  orderId: number,
  note: string,
  accessToken: string,
) {
  try {
    const response = await instance({
      method: 'PATCH',
      url: '/api/v1/order/note/add',
      data: { orderId, note },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
}
